import { Button } from '@selina-finance/ui';
import mixpanel from 'mixpanel-browser';
import { useNavigate } from 'react-router-dom';

export const HomePageView = () => {
    const navigate = useNavigate();

    const onClick = () => {
        mixpanel.track('Customise my offer');
        navigate('../questions');
    };

    const copy = {
        title: 'Let’s customise your quote',
        paragraphs: [
            'Tell us what you’re looking for so we can suggest the right option for you.',
            'Your answers won’t impact your eligibility, and you’ll still have multiple offers to choose from.',
        ],
    };

    return (
        <div className='flex flex-col mx-auto max-w-400 w-full lg:max-w-none lg:mt-24'>
            <div className='text-xl'>
                <div className='flex flex-col lg:flex-row-reverse lg:justify-end lg:gap-96'>
                    <div className='flex justify-center mt-18 mb-20 lg:mt-3'>
                        <img
                            src='/Icons/NeedsAndPreferencesIcon.svg'
                            alt='Needs and Preferences'
                        />
                    </div>
                    <div className='lg:w-371'>
                        <div>
                            <p className='mb-3 font-sora-bold text-2xl lg:text-28 tracking-tighter'>
                                {copy.title}
                            </p>
                            <div className='w-327'>
                                <p className='text-midnight-200 mb-3 text-lg'>
                                    {copy.paragraphs[0]}
                                </p>
                                <p className='text-midnight-200 text-lg'>
                                    {copy.paragraphs[1]}
                                </p>
                            </div>
                        </div>

                        <Button
                            color='secondary'
                            type='submit'
                            size={'large'}
                            className='mt-4 lg:mt-10 w-full'
                            onClick={onClick}
                        >
                            Continue
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
